export const MODELS_WITH_BOLD_DESCRIPTION = ['syn'];
